import { useEffect } from "react";
import { useContextHook } from "../../Context/ContextOPen";

const SuccessMessage = () => {
  const { successMessage, setSuccessMessage } = useContextHook();

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    } else {
      setSuccessMessage("");
    }
  }, [successMessage]);
  return (
    <>
      <div
        className={`fixed transition-all left-1/2 -translate-x-1/2 bg-whit shadow-lg z-[999999999999] overflow-hidden ${
          successMessage ? "bottom-10 " : "-bottom-full"
        }`}
        onClick={() => setSuccessMessage("")}
      >
        <div className="bg-Main text-white font-semibold py-2 px-7 min-w-[250px] text-center border-t-4 border-white">
          {successMessage && <p className="mb-2">{successMessage}</p>}
        </div>
      </div>
    </>
  );
};

export default SuccessMessage;
